<div (click)="buy()" class="product clickable">
    <div class="product-details">
        <div class="product-title">
            <div class="product-title-text">
                <span class="amount">{{ product.title ? product.title.split(' ')[0] : '' }}</span>
                <span>{{ " " }}</span>
                <span>{{ product.title ? product.title.split(' ')[1] : '' }}</span>
            </div>
            <div class="product-bonus" *ngIf="product.sweepbucksCount > 0 && isSweepBuckOn">
                <div class="product-bonus-text">{{ '+ ' + product.sweepbucksCount + ' BONUS ' }} <span>SWEEPS COINS</span></div>
            </div>
        </div>
        <div class="product-pic">
            <div class="gold-sweepsbucks" *ngIf="product.sweepbucksCount > 0; else gold">
                <div class="golds" [ngClass]="{'only-golds-adjust': !isSweepBuckOn}" [id]="animation ? 'gold-container-'+productId : ''">
                    <img [id]="goldIds(1) ? 'gold-' + productId : ''" class="gold-image" src="/assets/icon/chips/gold_chip.webp">
                    <img [id]="goldIds(2) ? 'gold-' + productId : ''" *ngIf="productId !== 'gold_5k' && productId !== 'gold_11k'" class="gold-image gold-image-second" src="/assets/icon/chips/gold_chip.webp">
                    <img [id]="goldIds(3) ? 'gold-' + productId : ''" *ngIf="productId === 'gold_130k'" class="gold-image gold-image-third" src="/assets/icon/chips/gold_chip.webp">
                </div>
                <div *ngIf="isSweepBuckOn" class="sweepsbucks">
                    <span class="plus plus-text" [ngClass]="{'plus-zindex': animation}" *ngIf="productId !== 'gold_60k' && productId !== 'gold_130k';else plus">+</span>
                    <img [id]="sweepsbuckIds(1) ? 'sweepsbuck-' + productId : ''" class="shadow-image sweepsbucks-image" src="assets/img/sweep/money.webp">
                    <img [id]="sweepsbuckIds(2) ? 'sweepsbuck-' + productId : ''" *ngIf="productId !== 'gold_5k'" class="sweepsbucks-image sweepsbucks-image-second" src="assets/img/sweep/money.webp">
                    <img [id]="sweepsbuckIds(3) ? 'sweepsbuck-' + productId : ''" *ngIf="productId === 'gold_130k'" class="sweepsbucks-image sweepsbucks-image-third" src="assets/img/sweep/money.webp">
                </div>
            </div>
        </div>
        <div class="product-flag" *ngIf="product.sweepbucksCount > 0 && isSweepBuckOn">
            <img src="/assets/img/bonus-flag.webp" alt="">
        </div>
    </div>
    <div class="product-price">
        <div class="product-price-text">{{ price || "N/A" }}</div>
    </div>
</div>

<ng-template #gold>
    <img [id]="goldIds(1) ? 'gold-' + productId : ''" src="/assets/icon/chips/gold_chip.webp">
</ng-template>

<ng-template #plus>
    <img class="plus plus-image" [ngClass]="{'plus-zindex': animation}"  src="assets/img/sweep/plus.webp">
</ng-template>
